
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { UserItemProps } from ".";
import { loading, update } from "store/user";

interface ApiUserUpdateInputProps extends UserItemProps {
}

type ApiUserUpdateOutputProps = OutputBaseProps<{ item: UserItemProps; }, ApiUserUpdateInputProps>

export const apiUserUpdate = async (data: ApiUserUpdateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiUserUpdateOutputProps>("/api/user/update", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
    }
    return res;
};